import {observer} from 'mobx-react-lite'
import React from 'react'
import {Lang} from 'yougile-lang'
import {ClickOut} from '@components/click-out'
import {DateRangePicker} from '@components/common/date-picker/date-picker'
import {Menu} from '@components/menu'
import {useStatsPageStore} from './stats-page-store'
import {getBoardName, listBoards} from './utils'

export const StatsPageChooser = observer(() => {
  const [state, store] = useStatsPageStore()

  const {filter} = state

  return (
    <div className="stp-chooser">
      <label className="stb-brd-label">
        {Lang.msg.fieldBoard}:
        <select
          className="stb-brd-select"
          value={filter.board.id}
          onChange={store.updateFilterBoard}
        >
          {listBoards().map(b => (
            <option key={b.id} value={b.id}>
              {getBoardName(b)}
            </option>
          ))}
        </select>
      </label>

      <label className="stb-dates-label">
        {Lang.msg.tsRange}:
        <select
          className="stb-dates-select"
          value={filter.datesType}
          onChange={store.updateFilterDatesType}
        >
          <option value="week">{Lang.msg.timeWeek}</option>
          <option value="2week">{Lang.msg.time2Week}</option>
          <option value="month">{Lang.msg.timeMonth}</option>
          <option value="custom">{Lang.msg.timeCustom}</option>
        </select>
      </label>

      {filter.datesType === 'custom' && (
        <div className="stp-filter-by-val">
          <span
            onClick={() => store.setChooseDate(!state.filter.chooseDate)}
            className="stp-filter-by-cur"
          >
            {store.datesTxt}
          </span>
          {filter.chooseDate && (
            <ClickOut cb={() => store.setChooseDate(false)}>
              <Menu onEscape={() => store.setChooseDate(false)}>
                <div className="stp-filter-by-edit">
                  <DateRangePicker
                    onChange={store.onDateChoose}
                    value={{start: filter.dates[0], end: filter.dates[1]}}
                  />
                </div>
              </Menu>
            </ClickOut>
          )}
        </div>
      )}
    </div>
  )
})
